import React, { useEffect, useState } from "react"
import { reactLocalStorage } from "reactjs-localstorage"
import config, { getHeaders } from "../config"
import './Profile.scss'
import { useHistory } from "react-router-dom";
import tick from "../assets/icons/green_tick.png"
import { SendGuiDataEvents } from "../CommonSript";
function Profile({ status_txt, validity_text, plantype_text }) {
    const [msisdn, setMsisdn] = useState('')
    const [status, setStatus] = useState('')
    const [displayStatus, setDisplayStatus] = useState('')
    const [msg, setMsg] = useState('')
    const [loading, setLoading] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [loader, setLoader] = useState(false)
    const [showUnSub, setShowUnSub] = useState('')
    let history = useHistory();
    const validity = reactLocalStorage.get("validity");
    const unsubmsg = reactLocalStorage.get("unsubmsg");
    useEffect(() => {
        const subStatus = reactLocalStorage.get("subStatus")
        const msisdn = reactLocalStorage.get("msisdn")
        const displayStatus = reactLocalStorage.get("status_display")
        const show_unsub = reactLocalStorage.get("showUnsub")
        setStatus(subStatus)
        setDisplayStatus(displayStatus)
        setShowUnSub(show_unsub)
        setMsisdn(msisdn)
        setLoading(false)
    }, [])

    useEffect(() => {
        let guiDataEvents = {};
        guiDataEvents["page"] = "profile";
        guiDataEvents["event"] = "open";
        SendGuiDataEvents(guiDataEvents);
    }, []);

    function handleBtnClick() {
        setLoader(true);
        const url = `${config.get('base')}${config.get('unsubscribe')}`
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ "uid": reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : "" }),
            headers: getHeaders()
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                console.log('result message::', result)
                checksub();
                setMsg(result.message)
                setShowUnSub(result.showUnsub)
                setOpenModal(true)
                reactLocalStorage.set("show_un_sub", JSON.stringify(result.showUnsub))
            },
                (error) => {
                    console.log('error:::', error)
                    setLoader(false)
                })
    }

    const checksub = () => {
        const url = `${config.get('base')}${config.get('checkSub')}`
        const uid = reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : "";
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 'uid': uid }),
            headers: getHeaders()
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                setLoader(false)
                console.log('result message::', result)
                reactLocalStorage.set("subStatus", result.subStatus)
                reactLocalStorage.set("status_display", result.status_display)
                reactLocalStorage.set("msisdn", result.msisdn)
                reactLocalStorage.set("unsub_text", result.unsub_msg_txt)
                reactLocalStorage.set("showUnsub", result.showUnsub)
            },
                (error) => {
                    setLoader(false)
                    console.log('error:::', error)
                })
    }


    function capitalizeFirstLetter(string) {
        if (string.toLowerCase() === 'failed') {
            string = "inactive"

        }
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    console.log("Status display ::", displayStatus)
    return (
        <>
            {loading ? <div className="ld-bg">
                <div className="lds"></div>
            </div> :
                <div className="container m-w">
                    <div className="columns is-mobile">
                        <div className="column is-full">
                            <div className="profile-card">
                                <div className="card-content"> {/* // add this className {"sub-line"} this if need a line  below the validity and sub plan  */}  
                                    <div className="display">
                                        <div className="text-start">
                                            <h3 className="">{status_txt}
                                            </h3>
                                            {displayStatus ? <div className="user-status">
                                                <h2 className="mt-4 semibold">{capitalizeFirstLetter(displayStatus)} </h2>
                                                <img src={tick} alt="tick" className="image" style={{ marginTop: "1rem", marginLeft: ".25rem" }} />
                                            </div>
                                                : <h2 className="mt-4">--</h2>
                                            }
                                        </div>
                                        <div className="text-right">
                                            <h3 className="">MSISDN</h3>
                                            {reactLocalStorage.get("msisdn") ? <h2 className="mt-4 semibold">{reactLocalStorage.get("msisdn")}</h2> :
                                                <h2 className="mt-4">--</h2>}
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="card-content">
                                    <div className="display">
                                        <div className="text-start">
                                            <h3 className="">{plantype_text}</h3>
                                            {reactLocalStorage.get("activePlan") ? <h2 className="mt-4 semibold">{reactLocalStorage.get("activePlan")}</h2> :
                                                <h2 className="mt-4">--</h2>}
                                        </div>
                                        <div className="text-right">
                                            <h3 className="">{validity_text}
                                            </h3>
                                            {displayStatus ? <div className="user-status">
                                                <h2 className="mt-4 semibold">{validity} </h2>
                                            </div>
                                                : <h2 className="mt-4">--</h2>
                                            }
                                        </div>

                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <h3 style={{ fontSize: '1rem' }} className="text-white text-center semibold">{unsubmsg}</h3> */}
                </div>
            }
        </>
    )
}

export default Profile
